import styled from '@emotion/styled'

export const StyleImagePreviewContainer = styled.div`
  height: 8rem;
  display: flex;
  gap: 10px;
  justify-content: center;
  padding: 10px;
`
export const ImagePreviewWrapper = styled.div`
  height: 100%;
  border-radius: 12px;
`
export const StyleImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 12px;
`
